<template>
	<div id="Products" class="products">
		<vue-snotify></vue-snotify>
		<!-- ######################################################################################
			 ####                                  Nav de opciones                             ####
			 ######################################################################################-->
		<nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchProducts"
					v-model="searchProducts"
					v-on:keyup.enter="getAllProducts(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllProducts(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
				<button class="btn btn-sm btn-outline-primary my-2 my-sm-1 margin-right5" title="Nuevo Producto" @click="showProductModalComponent">
					<i class="fas fa-plus"></i>
				</button>
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1 margin-right5" title="Buscar ubicación producto" @click="showProductLocationModal">
					<i class="fas fa-search-location" data-toggle="modal" data-target="#searchProductLocationModalComponent"></i>
				</button>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsProduct" @change="changeQRowsProduct">
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
			</div>
		</nav>
		
		<!-- ######################################################################################
			 ####                                  Lista de Productos                          ####
			 ######################################################################################-->
		<table class="table table-sm table-hover table-12">
			<thead>
				<tr class="text-center">
					<th>ID</th>
					<th>Nombre</th>
					<th>Sintetico</th>
					<th>ISBN</th>
					<th>Dimensiones</th>
					<th>Peso</th>
					<th>Grupo</th>
					<th>Tipo Producto</th>
					<th>Encuadernación</th>
					<th>Estado</th>
					<th>Editorial</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listProducts" :key="index">
					<td>{{ item.id }}</td>
					<td>{{ item.name }}</td>
					<td class="text-center">{{ item.synthetic }}</td>
					<td class="text-center">{{ item.isbn }}</td>
					<td class="text-center">{{ item.length }} x {{ item.width }} x {{ item.height }}</td>
					<td class="text-center">{{ item.weight }}</td>
					<td class="text-center">{{ item.group }}</td>
					<td class="text-center">{{ item.type_product }}</td>
					<td class="text-center">{{ item.type_binding }}</td>
					<td class="text-center">{{ item.status }}</td>
					<td class="text-center">{{ item.editorial }}</td>
					<td class="text-right">
						<i class="far fa-eye text-info margin-right5 pointer" @click="showProductLocal(item.id)"></i>
						<i class="fas fa-minus-circle text-danger pointer" @click="deleteProductLocal(item)"></i>
					</td>
				</tr>
			</tbody>
		</table>
		<pagination :pagination="paginationProducts" @getAllList="getAllProducts"></pagination>

		<product-modal-component
			:item="objectProduct"
			:listTypesProduct="listTypesProduct"
			:listTypesBinding="listTypesBinding"
			:listStatus="listStatus"
			:listEditorials="listEditorials"
			:listStores="listStores"
			:listStoreRacks="listStoreRacks"
			:listStoreRackModules="listStoreRackModules"
			@saveProduct="saveProduct"
			@saveProductLocation="saveProductLocation">
		</product-modal-component>
   		<button class="btn-link" data-toggle="modal" data-target="#productModalComponent" ref="btnShowProductModalComponent" v-show="1 == 2">Nuevo Producto</button>
		
		<search-product-location-modal-component ref="productModalComponent" 
			:item="objectProduct"
			:listTypesProduct="listTypesProduct"
			:listTypesBinding="listTypesBinding"
			:listStatus="listStatus"
			:listEditorials="listEditorials"
			@saveProduct="saveProduct">
		</search-product-location-modal-component>
   		<button class="btn-link" data-toggle="modal" data-target="#searchProductLocationModalComponent" ref="btnShowSearchProductLocationModalComponent" v-show="1 == 2">Nuevo Producto</button>

	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import product from '@/mixins/products'
import typeProduct from '@/mixins/products/typeProduct.js'
import typeBinding from '@/mixins/products/typeBinding.js'
import status from '@/mixins/status'
import editorial from '@/mixins/generals/editorial.js'
import store from '@/mixins/stores'
import storeRack from '@/mixins/stores/storeRack.js'
import storeRackModule from '@/mixins/generals/storeRackModule.js'

import Pagination from '@/components/Pagination.vue'
import ProductModalComponent from '@/components/ProductModalComponent.vue'
import SearchProductLocationModalComponent from '@/components/SearchProductLocationModalComponent.vue'

export default {
	name: 'Products',
	mixins: [axiosAction, errors, mixin, product, typeProduct, typeBinding, status, editorial, store, storeRack, storeRackModule],
	data() {
		return {
		}
	},
	computed: {
	},
	methods: {
		deleteProductLocal(item) {
			if(confirm('Está apunto de borrar el producto ' + item.name + '(' + item.id + ')\n¿Desea continuar?')) {
				this.deleteProduct(item.id)
			}
		},
		deleteProductResultLocal(response) {},
		initModuleLocal() {
			this.qRowsProduct = (localStorage.getItem('qRowsProduct') === null) ? this.qRowsProduct : localStorage.getItem('qRowsProduct')
			this.typeStatusId = 1
			this.setListeningProduct()
			this.getAllTypesBinding()
			this.getAllTypesProduct()
			this.getAllEditorials()
			this.getAllStores()
			this.getAllStoreRacks()
			this.getAllStoreRackModules()
			this.getAllStatus()
			this.getAllProducts()
		},
		getAllEditorialsResultLocal(response) {},
		getAllProductsResultLocal(response) {},
		getAllStoresResultLocal(response){},
		getAllStoreRacksResultLocal(response){},
		getAllStoreRackModulesResultLocal(response){},
		getAllTypesBindingResultLocal(response) {},
		getAllTypesProductResultLocal(response) {},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'deleteProductResult': this.deleteProductResult(response); break;
				case 'getAllEditorialsResult': this.getAllEditorialsResult(response); break;
				case 'getAllProductsResult': this.getAllProductsResult(response); break;
				case 'getAllStoreRacksResult': this.getAllStoreRacksResult(response); break;
				case 'getAllStoresResult': this.getAllStoresResult(response); break;
				case 'getAllStoreRackModulesResult': this.getAllStoreRackModulesResult(response); break;
				case 'getAllTypesBindingResult': this.getAllTypesBindingResult(response); break;
				case 'getAllTypesProductResult': this.getAllTypesProductResult(response); break;
				case 'getProductResult': this.getProductResult(response); break;
				case 'getTypeBindingResult': this.getTypeBindingResult(response); break;
				case 'getTypeProductResult': this.getTypeProductResult(response); break;
				case 'resultGetAllStatus': this.resultGetAllStatus(response); break;
				case 'saveProductResult': this.saveProductResult(response); break;
				case 'showProductResult': this.showProductResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		saveProductResultLocal(response) {
		},
		showProductLocal(id){
			this.showProduct(id)
		},
		showProductResultLocal(response) {
			this.setObjectProduct(response.data.data)
			this.$refs.btnShowProductModalComponent.click()
		},
		showProductLocationModal(){
		},
		showProductModalComponent() {
			this.clearObjectProduct()
			this.$refs.btnShowProductModalComponent.click()
		}
	},
	components: {
		'pagination': Pagination,
		'product-modal-component': ProductModalComponent,
		'search-product-location-modal-component': SearchProductLocationModalComponent
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>